import React from 'react'
import { array, object } from 'prop-types'
import './Episodes.scss'
import { handleKeyDown } from "../../utils/keyboard";

const Episodes = (props) => {
  const episodes = props.episodes ? props.episodes.sort((x, y) => y.sortOrder - x.sortOrder) : [];
  const handleChange = (e) => {
    if (window.appEventData) {
      window.appEventData.push({
        "event": "UI Item Clicked",
        "linkInfo": {
          "regions": "episode dropdown",
          "text": "Navigating to " + e.target.value,
        }
      });
    }
    window.location.replace(e.target.value);
  }
  const goToLatest = () => {
    const latestEpisodeLink = episodes[0].link
    if (window.appEventData) {
      window.appEventData.push({
        "event": "UI Item Clicked",
        "linkInfo": {
          "regions": "episode dropdown",
          "text": "Navigating to latest " + latestEpisodeLink,
        }
      });
    }
    window.location.assign(latestEpisodeLink);
  }
  return (
    <React.Fragment>
      <div className="sg-box dds-o-center">
        <h2 className="dds-c-section-title episode-header" data-align="center">
          EPISODES
        </h2>
        <div className="dds-c-form__field select-container">
          <select
            tabIndex="0" aria-label="list of all episodes"
            aria-activedescendant={props.selectedEpisode ? props.selectedEpisode.title : episodes[0].title}
            onChange={handleChange}
            id="select-field01"
            name="select-single"
            value={props.selectedEpisode ? props.selectedEpisode.link : episodes[0].link}
          >
            {episodes
              .map((x, index) => {
                return (
                  <React.Fragment key={x.sortOrder}>
                    <option
                      value={x.link}
                      data-latest={index === 0}
                    >
                      {x.title}
                    </option>
                  </React.Fragment>
                )
              })}
          </select>
          <div className="latest-label">
            <a onClick={goToLatest} onKeyDown={(e) => handleKeyDown(e, [13], goToLatest)} className="dds-c-link" tabIndex="0" role="button" aria-label='Go to latest episode'>
              LATEST
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Episodes.propTypes = {
  episodes: array,
  selectedEpisode: object
}

export default Episodes
